import { appEnv } from "@app/api/appEnv";
import { useAppSelector } from "@app/createStore";
import { useGetUserQuery } from "@auth/service/authLoginService";
import { LoadingPage } from "@shared/pages/LoadingPage";
import { Navigate, Outlet, useLocation } from "react-router-dom"
import { getCookie } from "typescript-cookie";

export const AuthenticationLayout = () => {
    const { pathname } = useLocation();
    const { isAuthenticated } = useAppSelector((state => state.auth));
    const { isLoading } = useGetUserQuery(undefined, {skip: !getCookie(appEnv.COOKIE_NAME)});

    if (isLoading) {
        return <LoadingPage />;
    }

    if (!isAuthenticated) {
        return <Navigate to={'/login'} replace/>;
    }

    if (isAuthenticated && pathname === '/login') {
        return <Navigate to={'/dashboard' } />;
    }

    if (pathname === '/') {
        return <Navigate to={'/dashboard'} replace />;
    }

    return <Outlet/>;
}